import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Smartphone, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { useAuth } from '@/context/AuthContext';
import API from '@/config/api';

export const ROLE_LABELS = [['parents', 'Parents'], ['staff', 'Staff'], ['drivers', 'Drivers']];

export const pct = ({ installed, total }) => (total ? Math.round((installed / total) * 100) : 0);

export const AppAdoptionWidget = () => {
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/app-installs/summary`, getAuthHeaders()).then((r) => setCounts(r.data.counts)).catch(() => {});
  }, [getAuthHeaders]);

  if (!counts) return null;
  return (
    <Card className="card-clay" data-testid="app-adoption-widget">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-primary" /> Mobile App Adoption
        </CardTitle>
        <Button variant="ghost" size="sm" onClick={() => navigate('/app-adoption')} data-testid="app-adoption-details-btn">
          Details <ArrowRight className="ml-1 w-4 h-4" />
        </Button>
      </CardHeader>
      <CardContent className="grid grid-cols-3 gap-4">
        {ROLE_LABELS.map(([key, label]) => (
          <div key={key} data-testid={`app-adoption-${key}`}>
            <p className="text-sm text-muted-foreground">{label}</p>
            <p className="font-heading font-bold text-2xl">
              {counts[key].installed}<span className="text-base text-muted-foreground font-semibold">/{counts[key].total}</span>
            </p>
            <Progress value={pct(counts[key])} className="h-2 mt-2" />
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
